
import VueMarkdown from 'vue-markdown'
import { SimpleSVG } from 'vue-simple-svg'
import ImageBlock from '~/components/ui/ImageBlock.vue'
import PreHead from '~/components/ui/PreHead.vue'
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    intro: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      svgLoaded: []
    }
  },
  components: {
    VueMarkdown,
    SimpleSVG,
    ImageBlock,
    PreHead
  },
  methods: {
    pushSVGLoaded(idx) {
      // this.$set(this.showSVGLoaded, idx, true)
      this.svgLoaded.push(idx)
    }
  }
}
